<template>
  <div class="web-box-all">
    <ext-header select_menu="6"></ext-header>

    <div class="web-home-main">

      <div class="web-order-box">
        <div class="web-order-left">
          <ext-nav></ext-nav>
        </div>
        <div class="web-order-right">

          <div class="web-order-title">
            <ul>
              <li class="select">
                <a>基本资料</a>
              </li>
            </ul>
          </div>

          <div class="web-store-info">
            <ul>
              <li>
                <a>门店名称：</a>
                <p>{{user_info.store_name}}</p>
              </li>
              <li v-if="company_no=='MCD-CHN'">
                <a>门店编码：</a>
                <p>{{user_info.store_no}}</p>
              </li>
              <li v-else>
                <a>门店账号：</a>
                <p>{{user_info.account}}</p>
              </li>
              <li v-if="user_info.zoneNo">
                <a>国际编码：</a>
                <p>{{user_info.zoneNo}}</p>
              </li>
              <li v-if="user_info.store_phone">
                <a>门店电话：</a>
                <p>{{user_info.store_phone}}</p>
              </li>
              <li v-if="user_info.store_region">
                <a>所属地区：</a>
                <p>{{user_info.store_region}}</p>
              </li>
              <li v-if="company_no=='MCD-CHN' && user_info.market_name">
                <a>所属市场：</a>
                <p>{{user_info.market_name}}</p>
              </li>
              <li v-if="user_info.user_name">
                <a>联系人：</a>
                <p>{{user_info.user_name}}</p>
              </li>
              <li v-if="user_info.user_phone">
                <a>联系电话：</a>
                <p>{{user_info.user_phone}}</p>
              </li>
               <li v-if="user_info.user_email">
                <a>联系邮箱：</a>
                <p>{{user_info.user_email}}</p>
              </li>
              <li v-if="user_info.store_address">
                <a>详细地址：</a>
                <p>{{user_info.store_address}}</p>
              </li>
            </ul>
          </div>

        </div>
      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import ExtNav from '@/components/leftnav/index'
import {getUserId, ajax, getCompanyNo} from '@/utils/extend'

export default {
  name: 'store_info',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-nav': ExtNav
  },
  data () {
    return {
      title: '门店信息',
      company_no: getCompanyNo(),
      user_info: {}
    }
  },
  mounted () {
    this.load_data()
  },
  methods: {
    load_data () {
      var that = this
      ajax({
        url: '/store/user/user_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.user_info = ret.data
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-box { width:100%; height:auto; flex-flow:row; align-content:flex-start; margin-top:20px;}
  .web-order-left { width:200px; height:auto; margin-right:15px; flex-wrap:wrap; align-content:flex-start;}

  .web-order-right { width:785px; height:auto; flex-wrap:wrap; align-content:flex-start;}

    .web-order-title { width:100%; height:50px; border-bottom: 1px solid #dfdfdf;}
      .web-order-title ul { width:400px; height:50px; list-style:none; margin:0px; padding:0px; flex-wrap:wrap; align-content:flex-start;}
      .web-order-title ul li { width:80px; height:50px; cursor: pointer; line-height: 50px; font-size:14px; text-align: center;justify-content:center; }
      .web-order-title ul li a { color:#333333;}
      .web-order-title ul li a:hover { color:#d81e06; font-weight: bold;}
      .web-order-title ul li.select { border-bottom: 2px solid #d81e06;}
   .web-store-info { width:100%; min-height: 402px; flex-wrap:wrap; margin-top:15px; border:1px  solid #dfdfdf; align-content:flex-start;}
      .web-store-info ul { width:100%; height: auto; list-style:none; margin-top:15px; flex-wrap:wrap; align-content:flex-start;}
      .web-store-info ul li { width:100%; height:40px; flex-flow:row; align-content:flex-start;}
      .web-store-info ul li a { width:80px; height:40px; line-height:40px; font-size:14px; color:#333333;}
      .web-store-info ul li p { width:auto; height:40px; line-height:40px; font-size:14px; color:#333333;}

</style>



// WEBPACK FOOTER //
// src/pages/store/store_info.vue